import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconRegistry } from '@angular/material/icon';
import { AuthService } from './services/auth.service';
import { Analytics, isSupported, logEvent } from '@angular/fire/analytics';
import { DevcycleService } from './services/devcycle.service';
import { TourMatMenuModule, TourService } from 'ngx-ui-tour-md-menu';
import { tourStation, tourSteps } from './shared/utils/tour';
import { SearchControlService } from './pages/map/controls/services/search-control.service';
import { OnboardingTourService } from './services/onboarding-tour.service';
import { SeoService } from './services/seo.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MatSidenavModule,
    MatToolbarModule,
    TourMatMenuModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    iconRegistry: MatIconRegistry,
    private authService: AuthService,
    private analytics: Analytics,
    private devcycleService: DevcycleService,
    private onboardingTourService: OnboardingTourService,
    private router: Router,
    private seoService: SeoService,
  ) {
    iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    isSupported().then((supported) => {
      if (supported) {
        console.log('🔥 Firebase Analytics is enabled');
        logEvent(this.analytics, 'test_event', { message: 'Firebase Analytics is working!' });
      } else {
        console.warn('⚠️ Firebase Analytics is not supported in this environment');
      }
    });
  }
  title = 'gitcharger-web';

  async ngOnInit() {
    this.devcycleService.initializeDevCycle();

    this.authService.getUserObject().subscribe((user) => {
      this.authService.userSignal.set(user ?? null);
    });

    this.onboardingTourService.start();

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        // Station details sets its own SEO after data loads.
        // For all other pages, reset to defaults so stale tags don't persist.
        if (!e.urlAfterRedirects.startsWith('/station/')) {
          this.seoService.reset();
        }
      });
  }
}
